<template>
  <div>
    <Card>
      <Row>
        <Button type="info" @click="add" :disabled="isChain">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate
        :columns="columns"
        :data="charge_coupons"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
    <Modal v-model="modalShow" @on-ok="handleSubmit" :title="$t('pages_banners_index_178')">
      <Form ref="charge_coupon" :model="charge_coupon" :label-width="100">
        <Form-item :label="$t('pages_charge_coupons_index_244')" prop="pay">
          <Input type="text" v-model="charge_coupon.pay" placeholder />
        </Form-item>
        <Form-item :label="$t('pages_charge_coupons_index_245')" prop="give">
          <Input type="text" v-model="charge_coupon.give" />
        </Form-item>
        <Form-item :label="$t('pages_bills_index_204')" prop="second_card">
          <Input type="text" v-model="charge_coupon.second_card" />
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      isChain: false,
      modalShow: false,
      charge_modal: false,
      formType: '',
      price: 0,
      machoneCardId: '',
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: i18n.t('pages_charge_coupons_index_244'),
          key: 'pay',
          align: 'center'
        },
        {
          title: i18n.t('pages_charge_coupons_index_245'),
          key: 'give',
          align: 'center'
        },
        {
          title: i18n.t('pages_bills_index_204'),
          key: 'second_card',
          align: 'center'
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at_str',
          align: 'center',
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          fixed: 'right',
          align: 'center',
          width: 200,
          render: (h, params) => {
            const children = []
            if (!this.isChain) {
              children.push(deleteButtonInTable(this, h, params))
            }
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  beforeCreate () {
    const sessionInfo = JSON.parse(localStorage.getItem('session-info'))
    if (sessionInfo) {
      this.isChain = sessionInfo.chain_store_manner === 'chain'
    }
  },
  created () {
    this.index()
  },
  computed: {
    ...mapGetters('charge_coupon', [
      'charge_coupon',
      'charge_coupons',
      'meta',
      'loading'
    ])
  },
  methods: {
    ...mapActions('charge_coupon', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('charge_coupon', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page, query: this.query })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    handleSubmit () {
      if (this.formType === 'edit') {
        this.update(this.charge_coupon)
      } else if (this.formType === 'new') {
        this.create(this.charge_coupon)
      }
      this.modalShow = false
    }
  }
}
</script>
